<section odxLayout="flex vertical-center horizontal-center" class="section">
  <header odxLayout="flex vertical-center">
    <div class="steps" odxLayout="grid 4">
      @for (step of steps; track step; let i = $index) {
        <div class="step-label">{{ step.label }}</div>
      }
    </div>
    <div class="steps steps-circles" odxLayout="grid 4">
      @for (step of steps; track step; let i = $index) {
        <div class="step-container" odxLayout="flex gap-small">
          <div class="step" odxLayout="flex vertical-center horizontal-center" [ngClass]="{ active: selectedIndex === i }">
            <span class="odx-text">{{ i + 1 }}</span>
          </div>
        </div>
      }
    </div>
  </header>

  <div class="content" [style.display]="selected ? 'block' : 'none'">
    @if (selected) {
      <ng-container [ngTemplateOutlet]="selected.content"></ng-container>
    }
  </div>
</section>
